import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { LoadingSpinner } from '../../../../components/Loader/Loader';
import http from '../../../../config/BaseUrl';
import { toast, ToastContainer } from 'react-toastify';

function ChangePassword({ user }) {

  const { register, handleSubmit, formState: { errors }, setError, watch, reset } = useForm({
    mode: "onChange",
    reValidateMode: "all"
  });

  const [isCheckPreviousPassword, setIsCheckPreviousPassword] = useState(false)
  const [isLoading, setLoading] = useState(false)


  const changePassword = (data) => {

    setLoading(true)
    if (data.old_password) {
      const submittedData = {
        old_password: data.old_password,
        email: user.email
      }
      http.post('/check-password', submittedData)
        .then(res => {
          setLoading(false)
          if (res.data.status === 'success') {
            setIsCheckPreviousPassword(true)
            toast.success(res.data.message)
          }
          else {
            setError("old_password", {
              type: "manual",
              message: res.data.message,
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
    else {
      const submittedData = {
        new_password: data.new_password,
        email: user.email
      }
      http.post('/update-password', submittedData)
        .then(res => {
          if (res.data.status === 'success') {
            toast.success(res.data.message)
            setIsCheckPreviousPassword(false)
            setLoading(false)
            reset({
              old_password: '',
              new_password: '',
              confirm_password: ''
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }

  }

  const password = watch("new_password", "")


  return (
    <div className='card'>
      <div className='card-header'>
        <h6 className='font-weight-bold'>Change Password</h6>
      </div>
      <form onSubmit={handleSubmit(changePassword)}>
        <div className='card-body'>
          <div className='form-group'>
            <label>Old Password</label>
            <input
              {...register("old_password", {
                required: "Please check the old password",
                disabled: isCheckPreviousPassword
              })}
              type='password'
              className='form-control'
              placeholder='Old Password'
            />
            <span className="text-danger font-size-14">{errors.old_password && errors.old_password.message}</span>
          </div>
          <div className='disabled-fields' style={{ opacity: isCheckPreviousPassword ? '1' : '.5' }}>
            <div className='form-group'>
              <label>New Password</label>
              <input
                {...register("new_password", {
                  required: "Please fill the new password",
                  minLength: {
                    value: 6,
                    message: "Password must have at least 6 characters"
                  },
                  disabled: !isCheckPreviousPassword
                })}
                type='password'
                className='form-control'
                placeholder='New Password'
              />
              <span className="text-danger font-size-14">{errors.new_password && errors.new_password.message}</span>
            </div>
            <div className='form-group'>
              <label>Confirm Password</label>
              <input
                {...register("confirm_password", {
                  required: "Please fill the confirm password",
                  disabled: !isCheckPreviousPassword,
                  validate: value => value === password || "Password doesn't match"

                })}
                type='password'
                className='form-control'
                placeholder='Confirm Password'
              />
              <span className="text-danger font-size-14">{errors.confirm_password && errors.confirm_password.message}</span>
            </div>
          </div>

        </div>
        <div className='card-footer text-right'>
          {isLoading ?
            (<button className="btn btn-primary rounded-pill px-4" disabled>
              <LoadingSpinner color="text-white" className="spinner-grow-sm" />
            </button>)
            :
            <button type='submit' className='btn btn-primary rounded-pill px-4'>
              {
                isCheckPreviousPassword ? 'Update Password' : 'Check Password'
              }
            </button>
          }
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </form>
    </div>
  )
}

export default ChangePassword